// Configuration centrale WhatsApp — modifiable plus tard depuis le CMS
export const WHATSAPP_NUMBER = "212688266025"; // Conceptions.ma — 06 88 26 60 25

export function buildWhatsappUrl(message: string, phone: string = WHATSAPP_NUMBER): string {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${phone}?text=${encoded}`;
}
